// extracted by mini-css-extract-plugin
module.exports = {"emptyBlock":"MyTasksStyles_emptyBlock__pgDp4","emptyBlock__card":"MyTasksStyles_emptyBlock__card__2DL70","emptyBlock__text":"MyTasksStyles_emptyBlock__text__3eXH5"};